<!-- 上传资料 -->
<template>
  <div>
    <van-steps active-color="#1989FA" :active="1">
      <van-step>填写信息</van-step>
      <van-step>上传资料</van-step>
      <van-step>资格审核</van-step>
      <van-step>办理手续</van-step>
    </van-steps>

    <div class="list-title">上传资料</div>
    <!-- 社保类 -->
    <template
      v-if="type === APPLY_TYPE.GZ4050SBBT ||
        type === APPLY_TYPE.SGPXBT ||
        type === APPLY_TYPE.SYBXWGBT"
    >
      <div class="list-item-title fwb">上传企业营业执照副本照片</div>
      <CUpload
        v-model="formData.business_license"
        :preview-url="TEMPLATE_IMAGES.business_license"
        @input="saveCache"
      ></CUpload>
    </template>
    <template
      v-if="type === APPLY_TYPE.ZYJSZGRD || type === APPLY_TYPE.ZYJSZGPS || type === APPLY_TYPE.ZYJSZGQR"
    >
      <div class="list-item-title fwb">上传社保明细</div>
      <CUpload
        v-model="formData.social_security_details"
        :preview-url="TEMPLATE_IMAGES.social_security_details"
        @input="saveCache"
      ></CUpload>
    </template>
    <template v-if="type === APPLY_TYPE.ZYJSZGRD || type === APPLY_TYPE.ZYJSZGPS">
      <div class="list-item-title fwb">上传毕业证照片</div>
      <CUpload v-model="formData.diploma" :preview-url="TEMPLATE_IMAGES.diploma" @input="saveCache"></CUpload>
    </template>
    <template v-if="type === APPLY_TYPE.ZYJSZGPS && preFormData.a20016===1">
      <div class="list-item-title fwb">上传专业技术资格证书照片</div>
      <CUpload
        v-model="formData.title_certificate"
        :preview-url="TEMPLATE_IMAGES.title_certificate"
        @input="saveCache"
      ></CUpload>
    </template>
    <template v-if="type === APPLY_TYPE.ZYJSZGQR">
      <div class="list-item-title fwb">上传资格证照片</div>
      <CUpload
        v-model="formData.qualification_certificate[0]"
        :preview-url="TEMPLATE_IMAGES.qualification_certificate"
        @input="saveCache"
      ></CUpload>
      <CUpload
        v-model="formData.qualification_certificate[1]"
        :preview-url="TEMPLATE_IMAGES.qualification_certificate2"
        @input="saveCache"
      ></CUpload>
      <div class="list-item-title fwb">已取得的职称认定表或评审表照片</div>
      <van-radio-group
        v-model="formData.photo_type"
        class="p-40 flex"
        direction="horizontal"
        @change="clearEvaluationPhoto();saveCache();"
      >
        <van-radio
          v-for="item in PHOTO_TYPE_DATA"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >{{ item.label }}</van-radio>
      </van-radio-group>
      <!-- 认定表 -->
      <template v-if="formData.photo_type === PHOTO_TYPE.IDENTIFY">
        <div key="evaluation_identify">
          <CUpload
            v-model="formData.evaluation_identify[0]"
            :preview-url="TEMPLATE_IMAGES.evaluation_identify"
            @input="saveCache"
          ></CUpload>
          <CUpload
            v-model="formData.evaluation_identify[1]"
            :preview-url="TEMPLATE_IMAGES.evaluation_identify2"
            @input="saveCache"
          ></CUpload>
        </div>
      </template>
      <!-- 评审表 -->
      <template v-else-if="formData.photo_type === PHOTO_TYPE.REVIEW">
        <div key="evaluation_review">
          <CUpload
            v-model="formData.evaluation_review[0]"
            :preview-url="TEMPLATE_IMAGES.evaluation_review"
            @input="saveCache"
          ></CUpload>
          <CUpload
            v-model="formData.evaluation_review[1]"
            :preview-url="TEMPLATE_IMAGES.evaluation_review2"
            @input="saveCache"
          ></CUpload>
        </div>
      </template>
    </template>

    <CFooter></CFooter>

    <div class="height-180"></div>
    <div class="fixed-bottom border-box p-40">
      <van-button
        block
        round
        type="info"
        :loading="isSubmitting"
        :disabled="isSubmitting"
        loading-text="提交中..."
        @click="handleSubmit"
      >立即提交审核</van-button>
    </div>
  </div>
</template>

<script>
import { cleanSessions } from "@/utils/utils"
import {
  APPLY_TYPE,
  CHANNEL,
  TEMPLATE_IMAGES,
  PHOTO_TYPE,
  PHOTO_TYPE_DATA,
} from "@share/enum"
import { submit as subsidySubmit } from "@/api/subsidy"
import { affirmationSubmit } from "@/api/professional"
import { reviewSubmit } from "@/api/professional"
import { confirmSubmit } from "@/api/professional"
import CFooter from "@/components/CFooter.vue"
import CUpload from "@/components/CUpload.vue"
import { Toast } from "vant"

export default {
  name: "SubsidyUpload",
  components: {
    CFooter,
    CUpload,
  },
  data: () => {
    return {
      APPLY_TYPE,
      TEMPLATE_IMAGES,
      type: "",
      preFormData: null,
      formData: null,
      isSubmitting: false,
      PHOTO_TYPE,
      PHOTO_TYPE_DATA,
    }
  },
  computed: {},
  created() {
    this.type = Number(this.$route.params.type)
    let formData = {}
    // 社保
    if (
      this.type === APPLY_TYPE.GZ4050SBBT ||
      this.type === APPLY_TYPE.SGPXBT ||
      this.type === APPLY_TYPE.SYBXWGBT
    ) {
      this.preFormData = {
        ...JSON.parse(sessionStorage.getItem("SUBSIDY_STEP_1") || null),
      }
      formData.business_license = ""
    } else if (
      // 职称服务
      this.type === APPLY_TYPE.ZYJSZGRD ||
      this.type === APPLY_TYPE.ZYJSZGPS ||
      this.type === APPLY_TYPE.ZYJSZGQR
    ) {
      this.preFormData = {
        ...JSON.parse(sessionStorage.getItem("TITLESERVICE_STEP_1") || null),
        ...JSON.parse(sessionStorage.getItem("TITLESERVICE_STEP_2") || null),
        ...JSON.parse(sessionStorage.getItem("TITLESERVICE_STEP_3") || null),
        ...JSON.parse(sessionStorage.getItem("TITLESERVICE_STEP_4") || null),
      }
      formData.social_security_details = ""
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        formData = {
          ...formData,
          social_security_details: "",
          diploma: "",
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        formData = {
          ...formData,
          social_security_details: "",
          diploma: "",
          title_certificate: "",
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGQR) {
        formData = {
          ...formData,
          social_security_details: "",
          qualification_certificate: ["", ""],
          photo_type: PHOTO_TYPE.IDENTIFY,
          evaluation_identify: ["", ""],
          evaluation_review: ["", ""],
        }
      }
    }
    const formDataCache = JSON.parse(sessionStorage.getItem("UPLOAD") || null)
    if (!formDataCache) {
      this.formData = formData
    } else {
      this.setFormParams(formDataCache)
    }
  },
  mounted() {},
  methods: {
    saveCache() {
      sessionStorage.setItem(
        "UPLOAD",
        JSON.stringify(this.getFormParams(this.formData))
      )
    },
    /** 提交 */
    handleSubmit() {
      const isSubsidy = [
        APPLY_TYPE.GZ4050SBBT,
        APPLY_TYPE.SGPXBT,
        APPLY_TYPE.SYBXWGBT,
      ].includes(this.type)
      const subsidy_type = isSubsidy ? this.type : undefined
      if (!this.checkSubmit()) return
      this.formData.channel = CHANNEL.WX
      this.formData.subsidy_type = subsidy_type
      this.isSubmitting = true
      const submitFunMap = {
        [APPLY_TYPE.GZ4050SBBT]: subsidySubmit,
        [APPLY_TYPE.SGPXBT]: subsidySubmit,
        [APPLY_TYPE.SYBXWGBT]: subsidySubmit,
        [APPLY_TYPE.ZYJSZGRD]: affirmationSubmit,
        [APPLY_TYPE.ZYJSZGPS]: reviewSubmit,
        [APPLY_TYPE.ZYJSZGQR]: confirmSubmit,
      }
      submitFunMap[this.type]({
        channel: CHANNEL.WX,
        ...this.preFormData,
        ...this.getFormParams(),
        subsidy_type,
      })
        .then((resp) => {
          this.isSubmitting = false
          this.$router.push({
            path: `/orderDetail/${resp.data.order_id}`,
          })
          cleanSessions()
        })
        .catch(() => {
          this.isSubmitting = false
        })
    },
    /** 设置表单参数 */
    setFormParams(data) {
      this.formData = {}
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        this.formData = {
          ...this.formData,
          social_security_details: data.a10018,
          diploma: data.a10019,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        this.formData = {
          ...this.formData,
          social_security_details: data.a20023,
          diploma: data.a20024,
          title_certificate: data.a20025,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGQR) {
        this.formData = {
          ...this.formData,
          social_security_details: data.a30005,
          qualification_certificate: data.a30006,
          evaluation_identify:
            data.a30008 === PHOTO_TYPE.IDENTIFY ? data.a30007 : ["", ""],
          evaluation_review:
            data.a30008 === PHOTO_TYPE.REVIEW ? data.a30007 : ["", ""],
          photo_type: data.a30008,
        }
      } else {
        this.formData = data
      }
    },
    /** 获取表单参数 */
    getFormParams() {
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        return {
          a10018: this.formData.social_security_details,
          a10019: this.formData.diploma,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        return {
          a20023: this.formData.social_security_details,
          a20024: this.formData.diploma,
          a20025: this.formData.title_certificate,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGQR) {
        let a30007 = ""
        if (this.formData.photo_type === PHOTO_TYPE.IDENTIFY) {
          a30007 = this.formData.evaluation_identify
        } else if (this.formData.photo_type === PHOTO_TYPE.REVIEW) {
          a30007 = this.formData.evaluation_review
        }
        return {
          a30005: this.formData.social_security_details,
          a30006: this.formData.qualification_certificate,
          a30007,
          a30008: this.formData.photo_type,
        }
      } else {
        return this.formData
      }
    },
    /** 校验提交 */
    checkSubmit() {
      if (
        this.type === APPLY_TYPE.GZ4050SBBT ||
        this.type === APPLY_TYPE.SGPXBT ||
        this.type === APPLY_TYPE.SYBXWGBT
      ) {
        if (!this.formData.business_license) {
          Toast("请上传企业营业执照副本照片")
          return false
        }
      } else {
        if (!this.formData.social_security_details) {
          Toast("请上传社保明细")
          return false
        }
        if (this.type === APPLY_TYPE.ZYJSZGRD) {
          if (!this.formData.diploma) {
            Toast("请上传毕业证照片")
            return false
          }
        } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
          if (!this.formData.diploma) {
            Toast("请上传毕业证照片")
            return false
          }
          if (this.preFormData.a20016 === 1) {
            if (!this.formData.title_certificate) {
              Toast("请上传专业技术资格证书照片")
              return false
            }
          }
        } else if (this.type === APPLY_TYPE.ZYJSZGQR) {
          if (
            !(
              this.formData.qualification_certificate[0] &&
              this.formData.qualification_certificate[1]
            )
          ) {
            Toast("请上传资格证照片")
            return false
          }
          if (!this.formData.photo_type) {
            Toast("请选择照片类型")
            return false
          }
          if (
            this.formData.photo_type === PHOTO_TYPE.IDENTIFY &&
            !(
              this.formData.evaluation_identify[0] &&
              this.formData.evaluation_identify[1]
            )
          ) {
            Toast("请上传认定表照片")
            return false
          }
          if (
            this.formData.photo_type === PHOTO_TYPE.REVIEW &&
            !(
              this.formData.evaluation_review[0] &&
              this.formData.evaluation_review[1]
            )
          ) {
            Toast("请上传评审表照片")
            return false
          }
        }
      }
      return true
    },
    clearEvaluationPhoto() {
      this.formData.evaluation_identify = ["", ""]
      this.formData.evaluation_review = ["", ""]
    },
  },
}
</script>

<style lang="scss" scope>
@import "~@/assets/style/app";
</style>
